function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var ClockFillSvg = function ClockFillSvg(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), React.createElement("defs", null, React.createElement("path", {
    id: "clock-fill_svg__a",
    d: "M10 0C4.477 0 0 4.477 0 10s4.477 10 10 10 10-4.477 10-10S15.523 0 10 0m5 10.5H9.5V3h1v6.5H15v1z"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(2 2)"
  }, React.createElement("mask", {
    id: "clock-fill_svg__b",
    fill: "#fff"
  }, React.createElement("use", {
    xlinkHref: "#clock-fill_svg__a"
  })), React.createElement("use", {
    fill: "#45494E",
    xlinkHref: "#clock-fill_svg__a"
  }), React.createElement("g", {
    mask: "url(#clock-fill_svg__b)"
  }, React.createElement("path", {
    fill: "#000",
    d: "M-2-2h24v24H-2z"
  }))));
};

ClockFillSvg.displayName = "ClockFillSvg";
export default ClockFillSvg;